import { useEffect, useState } from "react";

export default function useAsyncUpdate<T>(updateFunc: () => Promise<T>): [T | undefined, () => void] {
  const [value, setValue] = useState<T>();
  const update = () => {
    updateFunc().then(setValue);
  };
  useEffect(update, []);

  return [value, update];
}
